import { useApi, createApiHook } from "../utils/apiUtils";

const useCreateQuestionnaire = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const createQuestionnaire = async (payload) => {
    startLoading();
    const response = await apiPost("/questionnaires/create_with_survey", "Error al crear el cuestionario", payload);
    setResponse(response);
    return !response?.error;
  };

  return { createQuestionnaire, data, error, loading };
};

export default useCreateQuestionnaire;
